"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFabricPolygonObject = exports.FabricPolygon = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var fabric_1 = require("fabric");
var nanoid_1 = require("nanoid");
var fabricObjectUtils_1 = require("../fabricObjectUtils");
// define a function that can locate the controls.
// this function will be used both for drawing and for interaction.
var polygonPositionHandler = function (pointIndex) { return function (dim, finalMatrix, fabricObject) {
    var _a, _b, _c;
    var absolutePoint = fabric_1.fabric.util.transformPoint(new fabric_1.fabric.Point((((_a = fabricObject.points) === null || _a === void 0 ? void 0 : _a[pointIndex].x) || 0) - fabricObject.pathOffset.x, (((_b = fabricObject.points) === null || _b === void 0 ? void 0 : _b[pointIndex].y) || 0) - fabricObject.pathOffset.y), fabric_1.fabric.util.multiplyTransformMatrices(((_c = fabricObject.canvas) === null || _c === void 0 ? void 0 : _c.viewportTransform) || [], fabricObject.calcTransformMatrix()));
    return absolutePoint;
}; };
var getObjectSizeWithStroke = function (object) {
    var _a = object.scaleX, scaleX = _a === void 0 ? 1 : _a, _b = object.scaleY, scaleY = _b === void 0 ? 1 : _b, _c = object.width, width = _c === void 0 ? 1 : _c, _d = object.height, height = _d === void 0 ? 1 : _d, _e = object.strokeWidth, strokeWidth = _e === void 0 ? 1 : _e;
    var stroke = new fabric_1.fabric.Point(object.strokeUniform ? 1 / scaleX : 1, object.strokeUniform ? 1 / scaleY : 1).multiply(strokeWidth);
    return new fabric_1.fabric.Point(width + stroke.x, height + stroke.y);
};
// define a function that will define what the control does
// this function will be called on every mouse move after a control has been
// clicked and is being dragged.
// The function receive as argument the mouse event, the current trasnform object
// and the current position in canvas coordinate
// transform.target is a reference to the current object being transformed,
var actionHandler = function (pointIndex) { return function (eventData, transform, x, y) {
    var polygon = transform.target;
    // const currentControl = polygon.controls[polygon.__corner]
    var mouseLocalPosition = polygon.toLocalPoint(new fabric_1.fabric.Point(x, y), 'center', 'center');
    var polygonBaseSize = getObjectSizeWithStroke(polygon);
    var size = polygon._getTransformedDimensions(0, 0);
    var finalPointPosition = new fabric_1.fabric.Point((mouseLocalPosition.x * polygonBaseSize.x) / size.x + polygon.pathOffset.x, (mouseLocalPosition.y * polygonBaseSize.y) / size.y + polygon.pathOffset.y);
    polygon.points[pointIndex] = finalPointPosition;
    return true;
}; };
// define a function that can keep the polygon in the same position when we change its
// width/height/top/left.
var anchorWrapper = function (anchorIndex, fn) {
    return function (eventData, transform, x, y) {
        var fabricObject = transform.target;
        var absolutePoint = fabric_1.fabric.util.transformPoint(new fabric_1.fabric.Point(fabricObject.points[anchorIndex].x - fabricObject.pathOffset.x, fabricObject.points[anchorIndex].y - fabricObject.pathOffset.y), fabricObject.calcTransformMatrix());
        var actionPerformed = fn(eventData, transform, x, y);
        fabricObject._setPositionDimensions({});
        var polygonBaseSize = getObjectSizeWithStroke(fabricObject);
        var newX = (fabricObject.points[anchorIndex].x - fabricObject.pathOffset.x) / polygonBaseSize.x;
        var newY = (fabricObject.points[anchorIndex].y - fabricObject.pathOffset.y) / polygonBaseSize.y;
        fabricObject.setPositionByOrigin(absolutePoint, newX + 0.5, newY + 0.5);
        return actionPerformed;
    };
};
var isFabricPolygonObject = function (obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.type) === seesignage_utils_1.ObjectType.CustomPolygon;
};
exports.isFabricPolygonObject = isFabricPolygonObject;
var FabricPolygon = fabric_1.fabric.util.createClass(fabric_1.fabric.Polygon, {
    type: seesignage_utils_1.ObjectType.CustomPolygon,
    initialize: function (points, customOptions, options) {
        if (options === void 0) { options = {}; }
        this.callSuper('initialize', points, options);
        this.set({ customOptions: customOptions });
    },
    setPointEditMode: function () {
        var _a = this, pointEditMode = _a.customOptions.pointEditMode, points = _a.points;
        var cornerStyle, transparentCorners, hasBorders, controls;
        if (pointEditMode && points) {
            cornerStyle = 'circle';
            transparentCorners = false;
            hasBorders = false;
            var lastControl_1 = points.length - 1;
            controls = points.reduce(function (acc, point, index) {
                acc['p' + index] = new fabric_1.fabric.Control({
                    positionHandler: polygonPositionHandler(index),
                    actionHandler: anchorWrapper(index > 0 ? index - 1 : lastControl_1, actionHandler(index)),
                    actionName: 'modifyPolygon'
                });
                return acc;
            }, {});
        }
        else {
            cornerStyle = 'rect';
            transparentCorners = true;
            hasBorders = true;
            controls = fabric_1.fabric.Object.prototype.controls;
        }
        this.set({
            controls: controls,
            cornerStyle: cornerStyle,
            transparentCorners: transparentCorners,
            hasBorders: hasBorders
        });
    },
    setCustomOptions: function (customOptions) {
        var _a = this.customOptions, id = _a.id, version = _a.version;
        this.set({ customOptions: __assign(__assign({}, customOptions), { id: id, version: version }) });
        this.setPointEditMode();
    },
    toObject: function (generalPropertiesToInclude) {
        if (generalPropertiesToInclude === void 0) { generalPropertiesToInclude = [seesignage_utils_1.CanvasSaveMode.toMemory]; }
        var customPropertiesToInclude = ['customOptions', 'points'];
        var propertiesToInclude = __spreadArray(__spreadArray([], generalPropertiesToInclude.slice(1), true), customPropertiesToInclude, true);
        return (0, fabricObjectUtils_1.toObject)(this, propertiesToInclude);
    }
});
exports.FabricPolygon = FabricPolygon;
FabricPolygon.fromObject = function (combinedOptions, callback) {
    var customOptions = combinedOptions.customOptions, points = combinedOptions.points, options = __rest(combinedOptions, ["customOptions", "points"]);
    return callback(new FabricPolygon(points, customOptions, options));
};
window.fabric[seesignage_utils_1.ObjectType.CustomPolygon] = FabricPolygon;
var migrateObject = function (combinedOptions, callback) {
    var _a = combinedOptions.cId, cId = _a === void 0 ? (0, nanoid_1.nanoid)() : _a, cPolygonProps = combinedOptions.cPolygonProps, options = __rest(combinedOptions, ["cId", "cPolygonProps"]);
    delete options.type;
    delete options.cType;
    return FabricPolygon.fromObject(__assign(__assign({}, options), { customOptions: __assign({ id: cId, version: '1.0' }, cPolygonProps) }), callback);
};
window.fabric.Polygon.fromObject = migrateObject;
window.fabric.PolygonWithCustomControls = { fromObject: migrateObject };
//# sourceMappingURL=PolygonObject.js.map